<template>
  <div>
    <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field v-model="model" :label="label" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
      </template>
      <v-date-picker
        v-model="model"
        :locale="locale"
         @input="menuDate = false"
        :landscape="true">
      </v-date-picker>
    </v-menu>
    {{ description }}
  </div>
</template>

<script>
import { input } from '@/mixins/input'
export default {
    computed: {
      locale: () => process.env.VUE_APP_LOCALE
    },
    data(){
      return{
        menuDate:false
      }
    },
  mounted() {
    if(this.$route.query.date){
      this.model = this.$route.query.date
      this.value = this.$route.query.date
    }
  },
  mixins: [ input ]
}
</script>

<style>
</style>
